<template>
  <div class="vacancy-edit-features">
    <div class="vacancy-edit-features__head">
      <h3 class="vacancy-edit-features__title">{{$tNewVacancy2('features')}}</h3>
      <div class="vacancy-edit-features__translates  translates-btns">
        <div v-if="isOur" class="translates-btns__list">
          <button v-for="key in keys"
                  :key="key"
                  @click.prevent="onClick(key)"
                  :class="currentLangKeyComputed === key ? '_active' : null"
                  class="translates-btns__btn  reset-button">
            {{key | capitalize}}
            <span v-if="false"
                  class="translates-btns__tick">
              <BaseSvg name="ico-tick"/>
            </span>
          </button>
        </div>
      </div>
    </div>

    <div class="vacancy-edit-features__content">
      <div class="vacancy-edit-features__group">
        <div class="vacancy-edit-features__group-ico">
          <img src="../../assets/img/vacancy-features/1.png"
              :alt="$tVacancy('Official employment')">
        </div>
        <div class="vacancy-edit-features__inputs">
          <BaseInput :label="$tNewVacancy2('features_1')"
                     :value="getValue('features_1')"
                     @input="changeAction('features_1', $event)"
                     @blur="saveAction('features_1', getValue('features_1'))"
                     :placeholder="$tNewVacancy2('placeholder_features_1')"
                     class="vacancy-edit-features__input _white _shadow"/>
          <BaseInput :label="$tNewVacancy2('Description')"
                     textarea
                     :placeholder="$tNewVacancy2('placeholder_features_1_description')"
                     :value="getValue('features_1_description')"
                     @input="changeAction('features_1_description', $event)"
                     @blur="saveAction('features_1', getValue('features_1_description'))"
                     class="vacancy-edit-features__input _white _shadow"/>
        </div>
      </div>
      <div class="vacancy-edit-features__group">
        <div class="vacancy-edit-features__group-ico">
          <img src="../../assets/img/vacancy-features/2.png"
              :alt="$tVacancy('Official employment')">
        </div>
        <div class="vacancy-edit-features__inputs">
          <BaseInput :label="$tNewVacancy2('features_2')"
                     :value="getValue('features_2')"
                     @input="changeAction('features_2', $event)"
                     :placeholder="$tNewVacancy2('placeholder_features_2')"
                     @blur="saveAction('features_2', getValue('features_2'))"
                     class="vacancy-edit-features__input _white _shadow"/>
          <BaseInput :label="$tNewVacancy2('Description')"
                     textarea
                     :value="getValue('features_2_description')"
                     @input="changeAction('features_2_description', $event)"
                     :placeholder="$tNewVacancy2('placeholder_features_2_description')"
                     @blur="saveAction('features_2_description', getValue('features_2_description'))"
                     class="vacancy-edit-features__input _white _shadow"/>
        </div>
      </div>
      <div class="vacancy-edit-features__group">
        <div class="vacancy-edit-features__group-ico">
          <img src="../../assets/img/vacancy-features/3.png"
              :alt="$tVacancy('Official employment')">
        </div>
        <div class="vacancy-edit-features__inputs">
          <BaseInput :label="$tNewVacancy2('features_3')"
                     :value="getValue('features_3')"
                     @input="changeAction('features_3', $event)"
                     @blur="saveAction('features_3', getValue('features_3'))"
                     :placeholder="$tNewVacancy2('placeholder_features_3')"
                     class="vacancy-edit-features__input _white _shadow"/>
          <BaseInput :label="$tNewVacancy2('Description')"
                     textarea
                     :value="getValue('features_3_description')"
                     @input="changeAction('features_3_description', $event)"
                     :placeholder="$tNewVacancy2('placeholder_features_3_description')"
                     @blur="saveAction('features_3_description', getValue('features_3_description'))"
                     class="vacancy-edit-features__input _white _shadow"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapMutations, mapState} from "vuex"

  let timer = null

  export default {
    name: 'VacancyEditFeatures',
    data() {
      return {
        currentLangKey: null
      }
    },
    computed: {
      ...mapState('vacancyEdit/sectionDescription', [
        'inputs',
      ]),
      ...mapGetters('user', ['isOur']),
      keys() {
        let keys = [...Object.keys(this.$store.state.locales)]
        const currentLocale = this.$store.state.currentLocale
        let index = keys.findIndex(l => l === currentLocale)
        if (index > -1) {
          let v = keys.splice(index, 1)
          keys = v.concat(keys)
        }
        return keys
      },
      currentLangKeyComputed() {
        return this.currentLangKey || this.keys[0]
      },
    },
    methods: {
      onClick(key) {
        this.currentLangKey = key
      },
      ...mapMutations('vacancyEdit/sectionDescription', [
        'setInputValue'
      ]),
      ...mapActions('vacancyEdit', [
        'saveSection',
      ]),
      saveAction(key, value) {
        if(value) {
          let str = `Vacancy, Description. Field: ${key}, value: ${value}`

          this.$store.dispatch('sendAlert', {
            type: 'form',
            title: str
          })
        }
      },
      changeAction(key, value) {
        let prevVal = this.inputs[key].value
        if(typeof prevVal === 'string') {
          prevVal =  JSON.parse(prevVal)
        }

        if (!prevVal) {
          prevVal = {}
        }

        prevVal[this.currentLangKeyComputed] = value
        this.setInputValue([key, JSON.stringify(prevVal)])

        clearTimeout(timer)
        timer = setTimeout(() => {
          this.saveSection({
            sectionName: 'sectionDescription',
            fieldKey: key
          })
        }, 1000)
      },
      getValue(key) {
        let val = this.inputs[key].value
        if(typeof val === 'string') {
          val =  JSON.parse(val)
        }
        return val && val[this.currentLangKeyComputed] || null
      }
    }
  };
</script>

<style>

</style>
